module.exports = __webpack_public_path__ + "static/media/1@4x.ed77d71d.png";